import React from 'react';
import { Form } from '@douyinfe/semi-ui';
import { SingleTextStyleForm } from '../../components/SingleText';
import { MultiTextStyleForm } from '../../components/MultiText';
import { ModuleStyleForm } from '../../components/ModuleBase/ModuleBase';
import { config } from './config';

export const GroupTextStyleForm = ({ data = {}, onChange }) => {
    const defaultData = {
        ...config.defaultProps
    };

    const handleContentChange = (contentData) => {
        const newData = {
            ...defaultData,
            ...data,
            content: contentData.text,
            contentStyle: contentData.style
        };
        console.log("content what", contentData)
        onChange?.(newData);
    };

    const handleTitleChange = (titleData) => {
        const newData = {
            ...defaultData,
            ...data,
            title: titleData.text,
            titleStyle: titleData.style
        };
        onChange?.(newData);
    };

    const handleStyleChange = (style) => {
        const newData = {
            ...defaultData,
            ...data,
            ['style']: { ...data.style, ...style }
        };
        onChange?.(newData);
    };

    return (
        <Form labelPosition="left" labelAlign="right">
            <SingleTextStyleForm
                data={{
                    text: data?.title || defaultData.title,
                    style: data?.titleStyle || defaultData.titleStyle
                }}
                onChange={handleTitleChange}
            />
            <MultiTextStyleForm
                data={{
                    text: data?.content || defaultData.content,
                    style: data?.contentStyle || defaultData.contentStyle
                }}
                onChange={handleContentChange}
            />
            <ModuleStyleForm
                style={data?.style || defaultData.style}
                onChange={handleStyleChange}
            />
        </Form>
    );
};

export default GroupTextStyleForm;